import React from "react";
import { SortContext } from "./SortContext";

export default class SortButton extends React.Component {
	static contextType = SortContext

	static id = 1;

	constructor(props) {
		super(props);
		this.dropdown = React.createRef();

		var options = this.props.filterOptions;
		if (options && !Array.isArray(options)) {
			let arr = [];
			Object.keys(options).map(o => arr.push([this.props.isOptionsNumber ? parseInt(o) : o, options[o]]));
			options = arr.sort((a, b) => a[1].localeCompare(b[1]));
		}

		this.state = {
			direction: 0,
			showFilter: false,
			filter: [],
			options: options,
			filtered: false
		}
		this.changed = false;
	}

	componentDidMount() {
		this.context.initSort(this);
	}

	componentDidUpdate(prevProps, prevState) {
		if (!this.state.showFilter && prevState.filter.length != this.state.filter.length)
			this.setState({ filtered: this.state.filter.length });
	}

	showFilter = (e) => {
		e.stopPropagation();
		this.setState({ showFilter: true });
	}

	cancel = () => {
		$(this.dropdown.current).removeClass('show');
		this.setState({ filter: [], showFilter: false }, () => {
			this.context.onFilter(this, []);
		});
	}

	filter = () => {
		$(this.dropdown.current).removeClass('show');
		this.setState({ showFilter: false, filtered: this.state.filter.length }, () => {
			if (this.changed) {
				this.context.onFilter(this, this.state.filter);
				this.changed = false;
			}
		});
	}

	changeFilter = (o) => {
		let values = this.state.filter;
		let i = values.indexOf(o);
		if (i === -1)
			values.push(o);
		else
			values.splice(i, 1);
		this.setState({ filter: values });
		this.changed = true;
	}

	filterAll = () => {
		this.setState({ filter: this.state.filter.length != this.state.options.length ? this.state.options.map(o => o[0]) : [] });
		this.changed = true;
	}

	filterItem = (item) => {
		if (!this.state.filter.length)
			return true;
		const val = item[this.props.filterPropertyName];
		if (val instanceof Array)
			return val.some(i => this.state.filter.includes(i))
		return this.state.filter.indexOf(val) != -1;
	}

	render() {
		const inner = <>
			{this.props.children}
			{this.props.filterPropertyName && <span className="dropdown ms-2 fw-normal pointer"><em data-bs-toggle="dropdown" data-bs-auto-close="false" data-bs-reference="parent" className={"fa-solid dropdown-toggle " + (this.state.filtered ? "fa-filter-circle-xmark" : "fa-filter")} onClick={this.showFilter}></em>
				<div className="dropdown-menu dropdown-menu-end p-3" style={{ width: 300 }} ref={this.dropdown}>
					{this.state.showFilter && <><ul className="list-unstyled">
						<li onClick={this.filterAll} className="pointer"><em className={this.state.filter.length != this.state.options.length ? "fa-regular fa-square" : "fa-regular fa-square-check"}></em> {t.commonSelectAll}</li>
						<li><hr className="dropdown-divider" /></li>
					</ul><div className="mh-scroll"><ul className="list-unstyled">
						{this.state.options.map((o, i) => <li key={i} onClick={() => this.changeFilter(o[0])} className="pointer"><em className={this.state.filter.indexOf(o[0]) === -1 ? "fa-regular fa-square" : "fa-regular fa-square-check"}></em> {o[1]}</li>)}
					</ul></div><ul className="list-unstyled mb-0">
							<li><hr className="dropdown-divider" /></li>
							<li>
								<span className="btn btn-sm btn-default" onClick={this.cancel}>{t.commonClear}</span>
								<span className="btn btn-sm btn-secondary float-end" onClick={this.filter}>{t.commonFilter}</span>
							</li>
						</ul>
					</>}
				</div>
			</span>}
		</>;

		if (!this.props.propertyName)
			return inner;
		return (
			<div onClick={() => !this.state.showFilter && this.context.onSort(this)} className="pointer">
				<span className="me-2">
					{this.state.direction == -1 ? <em className="fa fa-arrow-up-short-wide"></em>
						: this.state.direction == 1 ? <em className="fa fa-arrow-down-short-wide"></em>
							: <em className="fa fa-sort"></em>}
				</span>
				{inner}
			</div>
		);
	}
}